import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';


class NotificationsNewTab extends React.Component {
    static propTypes = {
        notifications: PropTypes.array,
        markAllNotificationsAsRead: PropTypes.func,
        markNotificationAsRead: PropTypes.func,
        onNotificationClick: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            filter: 'all',
        };

        moment.tz.setDefault('Australia/Sydney');
    }

    handleFilterChange = (event) => {
        this.setState({
            filter: event.target.value,
        });
    };

    handleMarkAllAsRead = () => {
        const {
            markAllNotificationsAsRead,
        } = this.props;

        if (markAllNotificationsAsRead) {
            markAllNotificationsAsRead();
        }
    };

    handleMarkNotificationAsRead = (event, notification) => {
        event.stopPropagation();

        const {
            markNotificationAsRead,
        } = this.props;

        if (markNotificationAsRead) {
            markNotificationAsRead(notification.id);
        }
    };

    handleNotificationClick = (notification) => {
        const {
            onNotificationClick,
        } = this.props;

        if (onNotificationClick) {
            onNotificationClick(notification);
        }
    };

    getFilteredNotifications = () => {
        const {
            notifications = [],
        } = this.props;

        const {
            filter,
        } = this.state;

        if (filter === 'tickets_comments') {
            return notifications.filter(
                notification => (
                    notification.type === 'zendesk_ticket'
                    || notification.type === 'zendesk_comment'
                )
            );
        }

        if (filter === 'tracking') {
            return notifications.filter(
                notification => notification.type === 'status_update'
            );
        }

        return notifications;
    };

    getNotificationIcon = (notification) => {
        const title = notification.title || '';

        if (title.startsWith('New Ticket:')) {
            return {
                icon: 'fas fa-ticket-alt',
                className: 'ticket',
            };
        }

        if (title.startsWith('New reply from')) {
            return {
                icon: 'fa fa-comments',
                className: 'comment',
            };
        }

        return {
            icon: 'fa fa-bell',
            className: 'default',
        };
    };

    formatNotificationTime = (createdAt) => {
        if (!createdAt) {
            return '';
        }

        const created = moment(createdAt);
        const now = moment();

        const minutes = now.diff(created, 'minutes');
        const hours = now.diff(created, 'hours');
        const days = now.diff(created, 'days');

        if (minutes < 1) {
            return 'Just now';
        }

        if (minutes < 60) {
            return `${minutes} min${minutes === 1 ? '' : 's'} ago`;
        }

        if (hours < 24) {
            return `${hours} hr${hours === 1 ? '' : 's'} ago`;
        }

        if (days === 1) {
            return 'Yesterday';
        }

        if (days < 7) {
            return `${days} days ago`;
        }

        return created.format('D MMM YYYY');
    };

    renderNotification = (notification) => {
        const icon = this.getNotificationIcon(notification);

        return (
            <div
                key={notification.id}
                className='notification-card'
                onClick={() => this.handleNotificationClick(notification)}
            >
                <div className='notification-card-dot'></div>

                <div className={`notification-card-icon ${icon.className}`}>
                    <i
                        className={icon.icon}
                        aria-hidden='true'
                    />
                </div>

                <div className='notification-card-content'>
                    <div className='notification-card-title'>
                        {notification.title}
                    </div>

                    <div className='notification-card-description'>
                        {notification.description}
                    </div>

                    <div className='notification-card-time'>
                        {this.formatNotificationTime(
                            notification.created_at
                        )}
                    </div>
                </div>

                <button
                    type='button'
                    className='mark-notification-read-button'
                    onClick={(event) => (
                        this.handleMarkNotificationAsRead(
                            event,
                            notification
                        )
                    )}
                >
                    Mark as read
                </button>
            </div>
        );
    };

    render() {
        const notifications = this.getFilteredNotifications();

        return (
            <div className='notifications-new-tab'>
                <div className='notifications-actions'>
                    <select
                        className='notifications-filter'
                        value={this.state.filter}
                        onChange={this.handleFilterChange}
                    >
                        <option value='all'>
                            All
                        </option>

                        <option value='tickets_comments'>
                            Tickets &amp; comments
                        </option>

                        <option value='tracking'>
                            Tracking only
                        </option>
                    </select>

                    <button
                        type='button'
                        className='notifications-action-button'
                        onClick={this.handleMarkAllAsRead}
                        disabled={!notifications.length}
                    >
                        Mark all as read
                    </button>
                </div>

                {notifications.length === 0 ? (
                    <div className='center-content'>
                        No new notifications
                    </div>
                ) : (
                    <div className='notifications-list'>
                        {notifications.map(
                            this.renderNotification
                        )}
                    </div>
                )}
            </div>
        );
    }
}


export default NotificationsNewTab;


// WEBPACK FOOTER //
// src/components/Sliders/Notifications/NotificationsNewTab.js